import React from 'react';
import { Badge } from '@chakra-ui/react';

const STYLES = {
  owner: { color: 'role.ownerFg', bg: 'role.ownerBg', borderColor: 'role.ownerBorder' },
  admin: { color: 'role.adminFg', bg: 'role.adminBg', borderColor: 'role.adminBorder' },
  developer: { color: 'role.developerFg', bg: 'role.developerBg', borderColor: 'role.developerBorder' },
};

/** Small pill showing an org RBAC role. */
export default function RoleBadge({ role = 'developer', ...props }) {
  const key = String(role).toLowerCase();
  const s = STYLES[key] || STYLES.developer;
  return (
    <Badge
      textTransform="uppercase"
      fontSize="10px"
      fontWeight="700"
      letterSpacing="0.04em"
      borderWidth="1px"
      borderRadius="full"
      px={2.5}
      py={1}
      {...s}
      {...props}
    >
      {key}
    </Badge>
  );
}
